import React, { useContext, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { AppHeader } from "../AppHeader";
import { LocationContext } from "../../contexts/Location";
import { TrailList } from "../trail/TrailList";

interface MainLayoutProps {
  children?: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { trails } = useContext(LocationContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const { trailId } = useParams(); // Get trailId for sidebar selection

  // Determine selectedTrailId for TrailList from URL
  const selectedTrailIdFromUrl = trailId ?? null; // Ensure it's string or null

  // Determine if a sidebar should be rendered based on the current route
  const shouldRenderSidebar = location.pathname.startsWith('/trails');

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <AppHeader trailCount={trails.length} />
      <div className="flex-1 flex overflow-hidden">
        {shouldRenderSidebar && (
          <div
            className={`flex-shrink-0 border-r border-border shadow-lg transition-all duration-300 ${
              isSidebarCollapsed ? "w-16" : "w-80"
            }`}
          >
            <TrailList
              trails={trails}
              selectedTrailId={selectedTrailIdFromUrl}
              onSelectTrail={(id) => navigate(`/trails/${id}`)}
              onCreateNew={() => navigate('/trails/new')}
              isCollapsed={isSidebarCollapsed}
              onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
            />
          </div>
        )}
        <div className="flex-1 overflow-auto"> {/* Main content area */}
          {children || <Outlet />}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;